<template>
  <ExternalQueryList
      endpoint="/api/v2/mailing-lists"
      :endpoint-filters="{portal_id: portal.id}"
      :headlines="headlines"
      :filters="filters"
      :can-destroy="() => true"
      :can-update="() => true"
      @show="mailingList => $router.push(getUrl(mailingList))"
  >
    <template v-slot:default="{ row: mailingList }">
      <td>
        <router-link :to="getUrl(mailingList)">
          {{ mailingList.attributes.name }}
        </router-link>
      </td>

      <td>
        {{ mailingList.attributes.portal_name }}
      </td>
    </template>
  </ExternalQueryList>
</template>

<script>
import ExternalQueryList from '../../../Panels/Lists/ExternalQuery'

export default {
  components: {ExternalQueryList},

  props: {
    portal: {
      required: true
    }
  },

  computed: {
    headlines() {
      return [
        {width: 11, text: 'Name'},
        {width: 11, text: 'Portal'}
      ]
    },

    filters() {
      return [
        [
          {
            width: 20,
            widget: 'text',
            name: 'search',
            placeholder: 'Search...'
          },
          {
            width: 4,
            widget: 'submit'
          }
        ]
      ]
    }
  },

  methods: {
    getUrl(mailingList) {
      return '/portals/' + this.portal.id + '/mailing-lists/' + mailingList.id + '/edit'
    }
  }
}
</script>
